import { EventDTO } from '../../../dto/event/event.dto';
import {
  EventCategoryInheritanceContext,
  EventCategoryColorsMap,
  buildEventCategoryInheritanceContext,
  resolveEventCategoryBackgroundColor,
} from '../../../services/component-data-source/data/event/event-category-color.util';
import {
  normalizeEventIsActive,
  normalizeEventIsShown,
} from '../../../services/component-data-source/data/event/event-active.util';
import { extractEventTitle } from './extract-event-title.util';

export interface DunaScheduleEventRow {
  Id: string;
  Subject: string;
  StartTime: Date;
  EndTime: Date;
  IsAllDay: boolean;
  IsActive: boolean;
  IsShown: boolean;
  CategoryColor: string;
  EventType: string;
}

export function mapEventDtosToScheduleRows(
  events: EventDTO[],
  categoryColors: EventCategoryColorsMap = {},
  inheritanceContext?: EventCategoryInheritanceContext
): DunaScheduleEventRow[] {
  const ctx = inheritanceContext ?? buildEventCategoryInheritanceContext([]);
  return (events || [])
    .filter((event) => event?.guid)
    .map((event) => {
      const startTime = new Date(event.start_date);
      const endTime = new Date(event.end_date);
      const hasValidStart = !isNaN(startTime.getTime());
      const hasValidEnd = !isNaN(endTime.getTime());
      const spansMultipleDates =
        hasValidStart &&
        hasValidEnd &&
        (startTime.getFullYear() !== endTime.getFullYear() ||
          startTime.getMonth() !== endTime.getMonth() ||
          startTime.getDate() !== endTime.getDate());
      const calendarStartTime = new Date(startTime);
      const calendarEndTime = new Date(endTime);
      const useMultiDayCalendarSpan =
        event.event_duration_type === 'multi_day' && spansMultipleDates;
      if (useMultiDayCalendarSpan) {
        calendarStartTime.setHours(0, 0, 0, 0);
        calendarEndTime.setHours(0, 0, 0, 0);
        calendarEndTime.setDate(calendarEndTime.getDate() + 1);
      }
      const isActive = normalizeEventIsActive(event.is_active);
      const isShown = normalizeEventIsShown(event.is_shown);
      const categoryBg = resolveEventCategoryBackgroundColor(
        event,
        categoryColors,
        ctx
      );
      const defaultActiveColor = isActive ? '#445E91' : '#8f8f8f';
      return {
        Id: event.guid,
        Subject: extractEventTitle(event),
        StartTime: calendarStartTime,
        EndTime: calendarEndTime,
        IsAllDay: useMultiDayCalendarSpan,
        IsActive: isActive,
        IsShown: isShown,
        CategoryColor: categoryBg || defaultActiveColor,
        EventType: event.event_type,
      };
    });
}
